import { auth } from '@paeffgen/react/crm-documents/feature-auth';
import { createApolloClient } from './apollo-client';
import type { ApolloClient } from '@apollo/client';

/**
 * Create an authenticated Apollo Client for use in Server Components
 * and Route Handlers. Reads the access token from the server-side session.
 *
 * Each call creates a fresh client instance (no shared cache on the server).
 *
 * Usage in a Server Component:
 * ```ts
 * const client = await getServerGraphQLClient();
 * const { data } = await client.query({ query: DOCUMENTS_QUERY });
 * ```
 */
export async function getServerGraphQLClient(): Promise<ApolloClient> {
  const session = await auth();
  const token = session?.accessToken;
  return createApolloClient(() => token);
}
